/**
 * Touch-only open/close for PDP scent and plan dropdowns (.is-open mirrors :hover in CSS).
 */
(function pdpTouchDropdown() {
  const OPEN =
    '.collections-list-filters-options.is-open, .fieldsetWrapper.scent .display.is-open';

  const isTouch = () => window.matchMedia('(hover: none), (pointer: coarse)').matches;

  const closeAllExcept = (keep) => {
    document.querySelectorAll(OPEN).forEach((el) => {
      if (el !== keep) el.classList.remove('is-open');
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!isTouch()) return;

      const target = event.target;
      if (!(target instanceof Element)) return;

      const planItem = target.closest(
        '.shavingart__subscription-picker .collections-list-filters-options > .collections-list-category-filter'
      );
      const planList = planItem?.closest('.collections-list-filters-options');

      if (planList && planItem === planList.firstElementChild) {
        event.stopPropagation();
        if (planList.classList.contains('is-open')) planList.classList.remove('is-open');
        else {
          closeAllExcept(planList);
          planList.classList.add('is-open');
        }
        return;
      }

      const scentTrigger = target.closest('.fieldsetWrapper.scent .display .currently_selected');
      const scentDisplay = scentTrigger?.closest('.display');

      if (scentDisplay) {
        event.stopPropagation();
        if (scentDisplay.classList.contains('is-open')) scentDisplay.classList.remove('is-open');
        else {
          closeAllExcept(scentDisplay);
          scentDisplay.classList.add('is-open');
        }
        return;
      }

      document.querySelectorAll(OPEN).forEach((dropdown) => {
        if (!dropdown.contains(target)) dropdown.classList.remove('is-open');
      });
    },
    true
  );
})();
